import FollowingPageFilterDropdown from './FollowingPageFilterDropdown';
import NewDiscussionNotification from './NewDiscussionNotification';
import NewDiscussionTagNotification from './NewDiscussionTagNotification';
import NewPostNotification from './NewPostNotification';
import SubscriptionMenu from './SubscriptionMenu';
import SubscriptionMenuItem from './SubscriptionMenuItem';

export const components = {
  FollowingPageFilterDropdown,
  NewDiscussionNotification,
  NewDiscussionTagNotification,
  NewPostNotification,
  SubscriptionMenu,
  SubscriptionMenuItem,
};
